{
  "nav.reputation": "Reviews",
  "reputation.title": "Reviews",
  "reputation.count": "{count, plural, one {# review} other {# reviews}}",
  "reputation.tabs_label": "Review sections",
  "reputation.tab_inbox": "Inbox",
  "reputation.tab_sources": "Sources",
  "reputation.tab_invitations": "Invitations",
  "reputation.tab_display": "Website",
  "reputation.tab_insights": "Insights",
  "reputation.site_label": "Site",
  "reputation.site_all": "All sites",
  "reputation.action_connect": "Connect a source",
  "reputation.action_ask": "Ask for a review",
  "reputation.not_in_plan_title": "Reviews is not in your plan",
  "reputation.not_in_plan_body": "With Reviews you answer Google reviews from BRES and collect verified reviews on your own site.",
  "reputation.not_in_plan_action": "Register interest",
  "reputation.not_in_plan_sent": "Your interest has been passed on to BRES",
  "reputation.pro_title": "This is part of Reviews Pro",
  "reputation.pro_body": "Pro adds all sources, automatic invitations, channel managers and insights.",
  "reputation.empty_title": "No reviews connected yet",
  "reputation.empty_body": "Connect your Google profile or invite your clients to review you on your own site.",
  "reputation.empty_google_title": "Connect your Google profile",
  "reputation.empty_google_body": "You see all your Google reviews here and reply from BRES.",
  "reputation.empty_or": "Or start with",
  "reputation.empty_own": "Your own reviews on your site",
  "reputation.empty_own_meta": "After every sale or stay",
  "reputation.empty_trustpilot_meta": "Needs a plan with the API module",
  "reputation.empty_kiyoh_meta": "For Dutch and Belgian buyers",
  "reputation.empty_test_meta": "Local fake service to try connecting",
  "reputation.empty_all": "All services",
  "reputation.empty_filtered_title": "No reviews with these filters",
  "reputation.empty_filtered_body": "Change or clear the filters to see everything.",
  "reputation.clear_filters": "Clear filters",
  "reputation.summary_label": "Score per source",
  "reputation.summary_source": "{source} {value} from {count}",
  "reputation.counter_unanswered": "{count} unanswered",
  "reputation.counter_reported": "{count} reported",
  "reputation.counter_awaiting": "{count} awaiting publication",
  "reputation.counter_held": "{count} held",
  "reputation.search_label": "Search reviews",
  "reputation.search_placeholder": "Search text or name",
  "reputation.filter_source": "Source",
  "reputation.filter_source_all": "All sources",
  "reputation.filter_score": "Score",
  "reputation.filter_score_all": "All scores",
  "reputation.filter_status": "Status",
  "reputation.filter_status_all": "All statuses",
  "reputation.filter_language": "Language",
  "reputation.filter_language_all": "All languages",
  "reputation.filter_period": "Period",
  "reputation.filter_period_all": "Any time",
  "reputation.period_7d": "Last 7 days",
  "reputation.period_30d": "Last 30 days",
  "reputation.period_90d": "Last 90 days",
  "reputation.period_365d": "Last year",
  "reputation.score_n": "{n, plural, one {# star} other {# stars}}",
  "reputation.col_review": "Review",
  "reputation.col_rating": "Score",
  "reputation.col_status": "Status",
  "reputation.col_received": "Received",
  "reputation.more": "Load more",
  "reputation.rating_label": "{value} out of {scale}",
  "reputation.rating_label_count": "{value} out of {scale}, {count, plural, one {# review} other {# reviews}}",
  "reputation.anonymous": "Anonymous",
  "reputation.state.unanswered": "Unanswered",
  "reputation.state.answered": "Answered",
  "reputation.state.awaiting_source": "Waiting for the source",
  "reputation.state.awaiting_publication": "Awaiting publication",
  "reputation.state.held": "Held",
  "reputation.state.reported": "Reported",
  "reputation.state.removed": "Removed at the source",
  "reputation.state.rejected": "Not published",
  "reputation.state.draft": "Draft",
  "reputation.signal_translated": "Automatically translated on the site",
  "reputation.signal_verified": "Verified",
  "reputation.signal_internal": "Only in your admin: this source does not allow showing reviews on your site",
  "reputation.signal_screening": "Screening found something to check",
  "reputation.signal_demo": "Sample review (demo)",
  "reputation.signal_legacy": "Previously published, not verified",
  "reputation.sheet_title": "Review",
  "reputation.view_at": "View on {source}",
  "reputation.verified_booking": "Verified stay",
  "reputation.verified_sale": "Verified purchase",
  "reputation.verified_source": "Verified by the source",
  "reputation.legacy_provenance": "Previously published ({provenance})",
  "reputation.experience_stay": "Stay, {date}",
  "reputation.experience_sale": "Purchase, {date}",
  "reputation.experience_long_let": "Rental, {date}",
  "reputation.experience_service": "Service, {date}",
  "reputation.no_text": "A score only, without text.",
  "reputation.show_translation": "Show translation",
  "reputation.show_original": "Show original",
  "reputation.translation_published": "Automatically translated on your site",
  "reputation.translation_withheld": "Not published: the numbers in the translation did not match",
  "reputation.publish_after": "Appears on your site after {when}",
  "reputation.internal_notice": "Only in your admin. {source} does not allow publication on your own site.",
  "reputation.removed_notice": "This review was removed at the source and is no longer on your site.",
  "reputation.reply_title": "Reply",
  "reputation.reply_label": "Your reply",
  "reputation.reply_placeholder": "Say thanks, respond to the main point and keep it short.",
  "reputation.reply_counter": "{used} of {max}",
  "reputation.tone_label": "Tone",
  "reputation.tone_warm": "Warm",
  "reputation.tone_business": "Business",
  "reputation.tone_brief": "Brief",
  "reputation.suggest": "Suggest a reply",
  "reputation.suggest_test": "Suggestion (test adapter)",
  "reputation.post_google": "Post on Google",
  "reputation.post_site": "Post on your site",
  "reputation.post_source": "Post on {source}",
  "reputation.post_shortcut": "Ctrl+Enter posts",
  "reputation.saved_draft": "Draft saved",
  "reputation.saving_draft": "Saving draft…",
  "reputation.posted_toast": "Reply posted",
  "reputation.queued_toast": "Reply is on its way to {source}",
  "reputation.delete_reply": "Delete reply",
  "reputation.delete_reply_title": "Delete reply?",
  "reputation.delete_reply_body": "The reply disappears at the source and from your site.",
  "reputation.reply_state.draft": "Draft",
  "reputation.reply_state.queued": "Queued",
  "reputation.reply_state.posting": "Posting",
  "reputation.reply_state.pending_source": "Waiting for the source",
  "reputation.reply_state.published": "Posted",
  "reputation.reply_state.rejected_by_source": "Rejected by the source",
  "reputation.reply_state.failed": "Posting failed",
  "reputation.reply_from_source": "Your office's reply at the source",
  "reputation.copy_and_open": "Copy and open on {source}",
  "reputation.consent_missing": "First record at the source that BRES may reply on your behalf.",
  "reputation.connection_not_ready": "The connection is not working right now. You can reply once it is restored.",
  "reputation.no_reply_api": "{source} does not offer replies through its API.",
  "reputation.ack_checks": "I have checked these points",
  "reputation.check.amount": "Your reply mentions an amount. Check that you want to commit to it in public.",
  "reputation.check.compensation": "Your reply promises compensation or a discount.",
  "reputation.check.phone": "Your reply contains a phone number.",
  "reputation.check.email": "Your reply contains an email address.",
  "reputation.check.legal_threat": "Your reply contains legal language.",
  "reputation.check.accusation": "Your reply accuses the reviewer.",
  "reputation.check.booking_link": "Your reply points to direct booking or a link; many sources forbid this.",
  "reputation.check.too_long": "Your reply is longer than the source allows.",
  "reputation.check.test_output": "This is output from the test adapter. Rewrite it before posting.",
  "reputation.conflict_posted": "Someone else just posted a reply.",
  "reputation.conflict_view": "View",
  "reputation.moderation_title": "Moderation",
  "reputation.moderation_lead": "You can only decline with a reason from the list. The same rules apply to every score.",
  "reputation.reject": "Do not publish",
  "reputation.hold": "Hold for review",
  "reputation.release": "Release",
  "reputation.reject_reason": "Why are you not publishing this review?",
  "reputation.reject_note": "Explanation for the reviewer",
  "reputation.reject_evidence": "Evidence that the reviewer was not a customer",
  "reputation.reject_confirm": "Do not publish and inform the reviewer",
  "reputation.hold_confirm": "Hold",
  "reputation.release_confirm": "Release for publication",
  "reputation.hold_note": "What needs to be checked?",
  "reputation.reason.unlawful": "Unlawful content",
  "reputation.reason.abusive": "Abusive or discriminatory",
  "reputation.reason.personal_data": "Personal data of others or special category data",
  "reputation.reason.confidential": "Confidential information",
  "reputation.reason.spam_or_fake": "Spam or fake",
  "reputation.reason.off_topic": "Not about the service",
  "reputation.reason.not_a_customer": "Not a customer (evidence required)",
  "reputation.reason.screening_contact_data": "Screening: contact details in the text",
  "reputation.reason.screening_special_category": "Screening: possible special category data",
  "reputation.reason.screening_third_party": "Screening: name of a staff member or third party",
  "reputation.reason.screening_language": "Screening: words to check",
  "reputation.reason.moderator_check": "Review by a moderator",
  "reputation.reason.removed_at_source": "Removed at the source",
  "reputation.reason.reviewer_request": "At the reviewer's request",
  "reputation.reason.legal_order": "Legal order",
  "reputation.reason.disconnected": "Source disconnected",
  "reputation.reason.retention": "Retention period ended",
  "reputation.mark_before_change": "Mark as from before a change",
  "reputation.report_open": "Reported by a visitor: {reason}",
  "reputation.report_uphold": "Report is valid",
  "reputation.report_dismiss": "Dismiss report",
  "reputation.report_statement": "Statement for the reporter",
  "reputation.history_title": "History",
  "reputation.history.fetched": "Fetched from the source",
  "reputation.history.changed_at_source": "Changed at the source",
  "reputation.history.removed_at_source": "Removed at the source",
  "reputation.history.submitted": "Submitted on your site",
  "reputation.history.reply_saved": "Reply drafted",
  "reputation.history.reply_posted": "Reply posted",
  "reputation.history.reply_deleted": "Reply deleted",
  "reputation.history.reported": "Reported by a visitor",
  "reputation.history.translated": "Automatically translated",
  "reputation.history.published": "Published on the site",
  "reputation.history.purged": "Erased after the retention period",
  "reputation.history.moderation.publish": "Published",
  "reputation.history.moderation.hold": "Held",
  "reputation.history.moderation.release": "Released",
  "reputation.history.moderation.reject": "Not published",
  "reputation.history.moderation.remove": "Removed",
  "reputation.history.moderation.screened": "Screened",
  "reputation.history.moderation.mark_before_change": "Marked as from before a change",
  "reputation.history.moderation.report_resolved": "Report handled",
  "reputation.history_by": "by {name}",
  "reputation.sources_title": "Connected sources",
  "reputation.sources_empty": "No sources connected yet.",
  "reputation.sources_other": "Other services",
  "reputation.sources_other_lead": "What you can still connect, and what it takes.",
  "reputation.locations": "{count, plural, one {# location} other {# locations}}",
  "reputation.last_sync": "Fetched {when}",
  "reputation.never_synced": "Not fetched yet",
  "reputation.conn_status.awaiting_authorization": "Sign-in needed",
  "reputation.conn_status.connected": "Connected",
  "reputation.conn_status.needs_reauth": "Sign in again",
  "reputation.conn_status.degraded": "Fetching failed",
  "reputation.conn_status.paused": "Paused",
  "reputation.conn_status.disconnected": "Disconnected",
  "reputation.conn_status.error": "Error",
  "reputation.test_source": "Test source",
  "reputation.detail_locations": "Locations",
  "reputation.detail_runs": "Fetch runs",
  "reputation.detail_evidence": "Evidence level of the connection",
  "reputation.detail_webhook": "Webhook",
  "reputation.detail_webhook_lead": "Set this address at the service. You only see the secret now.",
  "reputation.detail_webhook_create": "Create webhook address",
  "reputation.detail_webhook_url": "Address",
  "reputation.detail_webhook_secret": "Secret",
  "reputation.run_outcome.succeeded": "Succeeded",
  "reputation.run_outcome.partial": "Partial",
  "reputation.run_outcome.failed": "Failed",
  "reputation.run_outcome.skipped": "Skipped",
  "reputation.run_counts": "{new} new, {updated} changed, {removed} removed",
  "reputation.run_trigger.schedule": "Scheduled",
  "reputation.run_trigger.push": "After a notification",
  "reputation.run_trigger.manual": "Manual",
  "reputation.run_trigger.initial": "First run",
  "reputation.run_trigger.deletions": "Deletions",
  "reputation.sync_now": "Fetch now",
  "reputation.sync_queued": "Fetching started",
  "reputation.pause": "Pause",
  "reputation.resume": "Resume",
  "reputation.reauth": "Sign in again",
  "reputation.disconnect": "Disconnect",
  "reputation.disconnect_title": "Disconnect {source}?",
  "reputation.disconnect_body": "The {count} {source} reviews disappear from your site right away. BRES revokes access and deletes them within 7 days.",
  "reputation.disconnect_confirm": "Disconnect",
  "reputation.disconnected_toast": "Disconnected",
  "reputation.public_on": "On your site",
  "reputation.public_off": "Only in your admin",
  "reputation.reply_consent": "BRES may post replies that you or your team confirm with Post.",
  "reputation.wizard_title": "Connect a source",
  "reputation.wizard_steps_label": "Steps",
  "reputation.wizard_step_choose": "Choose a service",
  "reputation.wizard_step_access": "Access",
  "reputation.wizard_step_locations": "Locations",
  "reputation.wizard_step_first": "First run",
  "reputation.wizard_search": "Search a service",
  "reputation.wizard_recommended": "Recommended for your office",
  "reputation.wizard_all": "All services",
  "reputation.avail.direct": "Connect directly",
  "reputation.avail.test": "Local test source, never a real service",
  "reputation.avail.trustpilot": "Needs a Trustpilot plan with the API module",
  "reputation.avail.internal": "Only in your admin: {name} does not allow showing reviews on your own site",
  "reputation.avail.airbnb_direct": "Not directly possible: Airbnb only shares reviews with partners. Do you use Hostaway or Guesty? Connect that instead.",
  "reputation.avail.booking_direct": "Not directly possible: Booking.com only shares reviews with connectivity partners. Do you use Hostaway or Guesty? Connect that instead.",
  "reputation.avail.expedia_direct": "Not directly possible: Vrbo and Expedia only share reviews with connectivity providers.",
  "reputation.avail.meta_recommendations": "Discontinued: Meta no longer offers Facebook recommendations.",
  "reputation.avail.google_places": "Not used: the Places API shows at most five reviews and forbids storage.",
  "reputation.avail.real_estate_portals": "Not available: property portals offer no API for agent reviews.",
  "reputation.avail.widget_services": "Not supported: third-party scripts only, which make your site slower and less secure.",
  "reputation.avail.avantio": "Not available yet: BRES is requesting the API specification.",
  "reputation.avail.waiting_bres": "Waiting for BRES: {missing}",
  "reputation.avail.awaiting_contract": "First needs an agreement with {name}",
  "reputation.avail.pro": "Reviews Pro",
  "reputation.access_oauth_lead": "BRES reads your reviews and the source's score, and only posts replies you confirm.",
  "reputation.access_login": "Sign in with {source}",
  "reputation.access_waiting": "Sign in in the window that opened. This screen continues by itself.",
  "reputation.access_popup_blocked": "The window was blocked. You now continue through a full redirect.",
  "reputation.access_failed": "Signing in did not work. Try again.",
  "reputation.access_keys_lead": "You find these details in your own {source} account.",
  "reputation.access_keys_help": "Where do I find this?",
  "reputation.access_check": "Check key",
  "reputation.access_ok": "Key checked and stored securely",
  "reputation.access_rejected": "{source} does not accept these details. Check that the API module is active.",
  "reputation.show_secret": "Show",
  "reputation.hide_secret": "Hide",
  "reputation.locations_lead": "Choose which locations to connect and where they belong.",
  "reputation.locations_none": "The service returned no locations.",
  "reputation.location_site": "Site",
  "reputation.location_site_none": "No site",
  "reputation.location_property": "Property",
  "reputation.location_property_none": "No property",
  "reputation.location_public": "Show on your website",
  "reputation.location_public_forbidden": "This source does not allow showing reviews on your website.",
  "reputation.location_link_only": "Only a link to the source",
  "reputation.first_running": "Fetching reviews…",
  "reputation.first_done": "{count, plural, one {# review} other {# reviews}} found",
  "reputation.first_done_avg": "{count, plural, one {# review} other {# reviews}} found, average {value} on {source}",
  "reputation.first_latest": "Latest reviews",
  "reputation.wizard_next": "Next",
  "reputation.wizard_back": "Back",
  "reputation.wizard_finish": "Finish connecting",
  "reputation.wizard_save_locations": "Connect locations and fetch",
  "reputation.connected_toast": "{source} is connected",
  "reputation.consent_give": "Record consent",
  "reputation.consent_withdraw": "Withdraw consent",
  "reputation.kind.sale": "After a purchase",
  "reputation.kind.stay": "After a stay",
  "reputation.kind.long_let": "After a tenancy",
  "reputation.kind.service": "After a service",
  "reputation.rules_title": "When you invite",
  "reputation.rules_lead": "Everyone with a completed experience gets the same invitation. There is no satisfaction filter and no reward.",
  "reputation.rules_pro_body": "Automatic invitations are part of Reviews Pro. You can still ask for a review per experience.",
  "reputation.pro_badge": "Pro",
  "reputation.rule_summary": "{days, plural, =0 {Right after the experience} one {# day after the experience} other {# days after the experience}}{reminder, plural, =0 {, no reminder} other {, reminder after # days}}",
  "reputation.rule_off": "Off: manual invitations only",
  "reputation.rule_delay": "Send after",
  "reputation.days": "days",
  "reputation.rule_reminder": "Reminder",
  "reputation.rule_reminder_none": "No reminder",
  "reputation.rule_reminder_after": "Once, after {days} days",
  "reputation.rule_destination": "Destination",
  "reputation.destination.bres": "Own reviews on your site",
  "reputation.rule_reason_title": "Why are you changing the rule?",
  "reputation.rule_reason_body": "Every change is logged with a reason, so you can later show that everyone is invited the same way.",
  "reputation.rule_reason": "Reason",
  "reputation.rule_reason_placeholder": "For example: earlier reminder, guests reply faster",
  "reputation.rule_saved": "Rule saved",
  "reputation.preview_title": "Email preview",
  "reputation.preview_language": "Language",
  "reputation.preview_kind": "Type of experience",
  "reputation.preview_variant": "Email",
  "reputation.preview_invite": "Invitation",
  "reputation.preview_reminder": "Reminder",
  "reputation.preview_subject": "Subject:",
  "reputation.preview_frame": "Preview of the invitation email",
  "reputation.invitations_title": "Invitations",
  "reputation.invitations_empty": "No invitations yet",
  "reputation.invitations_empty_body": "Record a sale or stay, or import guests. The invitation follows the rule above.",
  "reputation.invite_all": "All ({count})",
  "reputation.invite_no_site": "There is no site to invite for yet",
  "reputation.col_invitee": "Client",
  "reputation.col_when": "When",
  "reputation.col_expires": "Expires",
  "reputation.invitee_unknown": "Unknown contact",
  "reputation.invite_when_planned": "Planned {date}",
  "reputation.invite_when_sent": "Sent {date}",
  "reputation.invite_when_submitted": "Submitted {date}",
  "reputation.invite_status.scheduled": "Planned",
  "reputation.invite_status.sent": "Sent",
  "reputation.invite_status.reminded": "Reminded",
  "reputation.invite_status.submitted": "Submitted",
  "reputation.invite_status.expired": "Expired",
  "reputation.invite_status.skipped": "Skipped",
  "reputation.invite_status.unsubscribed": "Unsubscribed",
  "reputation.invite_status.failed": "Failed",
  "reputation.invite_retry": "Send again",
  "reputation.invite_skip": "Skip",
  "reputation.skip_title": "Skip {name}",
  "reputation.skip_body": "You can only skip for one of these reasons. Satisfaction is not a reason.",
  "reputation.skip_reason": "Reason",
  "reputation.skip_confirm": "Skip",
  "reputation.skip.objection": "Objected",
  "reputation.skip.legal_dispute": "Legal dispute",
  "reputation.skip.deceased": "Deceased",
  "reputation.skip.no_valid_address": "No valid address",
  "reputation.skip.staff_or_owner": "Staff or owner",
  "reputation.skip.suppressed": "On the unsubscribe list",
  "reputation.skip.no_consent": "No consent (country)",
  "reputation.skip.module_off": "Module off",
  "reputation.experience_action": "Record experience",
  "reputation.experience_title": "Record experience",
  "reputation.experience_body": "After a sale or stay. The invitation follows the rule, or goes right away when no rule is on.",
  "reputation.experience_contact": "Client",
  "reputation.experience_contact_placeholder": "Search by name or email",
  "reputation.experience_kind": "Type",
  "reputation.experience_date_sale": "Completion date",
  "reputation.experience_date_stay": "Departure date",
  "reputation.experience_date_hint": "You can invite up to 30 days after this date.",
  "reputation.experience_reference": "Reference",
  "reputation.experience_property": "Property",
  "reputation.experience_notice": "BRES automatically skips staff, addresses on the unsubscribe list and recipients without the required consent.",
  "reputation.experience_submit": "Record",
  "reputation.experience_saved": "Experience recorded, invitation planned",
  "reputation.import_action": "Import guests",
  "reputation.import_title": "Import guests",
  "reputation.import_body": "A CSV with name, email and date. You first see what happens per row; only then do you record the experiences.",
  "reputation.import_file": "Choose CSV",
  "reputation.import_paste": "Or paste the contents",
  "reputation.import_column_none": "No column",
  "reputation.import_map_name": "Name column",
  "reputation.import_map_email": "Email column",
  "reputation.import_map_date": "Date column",
  "reputation.import_map_reference": "Reference column",
  "reputation.import_check": "Check",
  "reputation.import_apply": "{count, plural, one {Record # experience} other {Record # experiences}}",
  "reputation.import_summary": "{ok} fine, {problems} with a problem",
  "reputation.import_ok": "Fine",
  "reputation.import_done": "{count, plural, one {# experience recorded} other {# experiences recorded}}",
  "reputation.import_problem.email": "No valid email address",
  "reputation.import_problem.date": "Unreadable date",
  "reputation.import_problem.future": "Date in the future",
  "reputation.import_problem.too_old": "Older than 30 days",
  "reputation.import_problem.duplicate": "Duplicate in the file",
  "reputation.moderation_saved": "Decision saved",
  "reputation.report_saved": "Report handled",
  "reputation.report_confirm": "Save",
  "reputation.report_external": "Only {source} can remove a {source} review. Report it there if it breaks the rules.",
  "reputation.reject_note_hint": "The reviewer receives this explanation by email, together with the reason.",
  "reputation.report_reason.unlawful": "unlawful",
  "reputation.report_reason.abusive": "abusive",
  "reputation.report_reason.personal_data": "personal data",
  "reputation.report_reason.spam_or_fake": "spam or fake",
  "reputation.report_reason.off_topic": "not about the service",
  "reputation.report_reason.other": "other",
  "reputation.won_title": "Ask {name} for a review?",
  "reputation.won_body": "Record the completion date. The invitation follows the site's rule, the same way as for everyone.",
  "reputation.won_later": "Not now",
  "reputation.won_confirm": "Record",
  "reputation.won_future": "The completion is in the future. Record the experience after completion.",
  "reputation.reject_published": "Remove from the site",
  "reputation.insights_empty": "Nothing to show yet",
  "reputation.insights_empty_body": "Once reviews come in you will see the trend per source, your reply time and recurring themes here.",
  "reputation.insights_stats": "Key figures for the last twelve months",
  "reputation.insights_reply_rate": "Answered",
  "reputation.insights_reply_rate_meta": "{answered} of {total} reviews",
  "reputation.insights_reply_time": "Reply time",
  "reputation.insights_reply_time_meta": "Median, from review to reply",
  "reputation.insights_hours": "{n} hours",
  "reputation.insights_days": "{n} days",
  "reputation.insights_invites": "Invitation became review",
  "reputation.insights_invites_meta": "{submitted} of {sent} invitations sent",
  "reputation.insights_none": "None yet",
  "reputation.insights_monthly": "Reviews per month, per source",
  "reputation.insights_source_avg": "{avg} average from {count, plural, one {# review} other {# reviews}}",
  "reputation.insights_not_merged": "Each source keeps its own score. BRES never merges sources into one average.",
  "reputation.insights_themes": "Recurring themes",
  "reputation.insights_themes_run": "Find themes",
  "reputation.insights_themes_again": "Find again",
  "reputation.insights_themes_lead": "AI reads the text and score of your published reviews (no names) and groups what comes up more often. You only see themes that at least two reviews mention.",
  "reputation.insights_themes_test": "Found by the test adapter using keywords, not by a language model.",
  "reputation.insights_themes_none": "No theme comes up in at least two reviews.",
  "reputation.insights_theme_count": "{count, plural, one {# review} other {# reviews}}",
  "reputation.insights_themes_at": "Found on {date}",
  "reputation.theme.communication": "Communication",
  "reputation.theme.guidance": "Guidance and explanation",
  "reputation.theme.paperwork": "Paperwork and notary",
  "reputation.theme.costs": "Costs",
  "reputation.theme.speed": "Lead time",
  "reputation.theme.after_sales": "After the sale",
  "reputation.theme.location": "Location",
  "reputation.theme.cleanliness": "Cleanliness",
  "reputation.theme.property_condition": "Property condition",
  "reputation.theme.value": "Value for money",
  "reputation.sentiment.positive": "Positive",
  "reputation.sentiment.negative": "Critical",
  "reputation.sentiment.mixed": "Mixed",
  "reputation.display_no_filter": "There is no setting to filter reviews by score or publish them later. The selection always picks the newest reviews, whatever the score.",
  "reputation.display_where": "Where reviews appear",
  "reputation.display_placements": "Places on the site",
  "reputation.placement.home": "Home page",
  "reputation.placement.property": "Property page",
  "reputation.placement.reviews_page": "Own reviews page",
  "reputation.placement.about": "About us",
  "reputation.display_variant": "Style",
  "reputation.variant.light": "Light",
  "reputation.variant.dark": "Dark",
  "reputation.variant.photo": "Over a photo",
  "reputation.display_selection": "Selection and score",
  "reputation.display_selection_lead": "The site shows the newest reviews above the minimum length, next to the full average, the distribution and a link to all reviews.",
  "reputation.display_count": "Number of reviews in the selection",
  "reputation.display_min_length": "Minimum length",
  "reputation.display_chars": "characters",
  "reputation.display_window": "Period for the own average",
  "reputation.display_window_all": "All published reviews",
  "reputation.display_window_months": "Last {months} months",
  "reputation.display_delay": "Waiting time for own reviews",
  "reputation.display_hours": "hours",
  "reputation.display_delay_hint": "The same for every score. In this time you can reply or record a valid reason.",
  "reputation.display_replies": "Show the office's replies",
  "reputation.display_distribution": "Show the score distribution",
  "reputation.display_translate": "Translate own reviews automatically (with label and original)",
  "reputation.display_order": "Order of the sources",
  "reputation.display_order_lead": "Each source keeps its own score; the order only decides which source comes first.",
  "reputation.display_up": "Move {source} up",
  "reputation.display_down": "Move {source} down",
  "reputation.display_gvr": "Reviews in VacationRental data for Google",
  "reputation.display_gvr_hint": "Only with a Google Vacation Rentals connection. Never on agency or organisation pages.",
  "reputation.display_preview": "Save and update preview",
  "reputation.display_saved": "Display saved",
  "reputation.display_preview_started": "Display saved; the preview is being updated",
  "reputation.display_preview_title": "Preview of {site}",
  "reputation.display_desktop": "Desktop",
  "reputation.display_mobile": "Mobile",
  "reputation.display_device": "Device",
  "reputation.display_last_preview": "Preview version {revision}, {date}",
  "reputation.display_no_preview": "No preview made yet",
  "reputation.google_lead": "Show on your site what clients say about you on Google. Free: BRES fetches the reviews from your Google Business Profile and shows them in your site's own style, with a button to write a review on Google.",
  "reputation.google_business": "Your business on Google",
  "reputation.google_login_lead": "Sign in with the Google account that manages your Business Profile and pick your business. BRES only reads your reviews; you reply on Google itself.",
  "reputation.google_login": "Sign in with Google",
  "reputation.google_relogin": "Sign in again",
  "reputation.google_login_failed": "Signing in with Google did not work",
  "reputation.google_waiting": "Finish signing in in the Google window that just opened.",
  "reputation.google_not_ready": "BRES is still finishing the connection with Google. Until then you can put a button to your Google reviews on your site below.",
  "reputation.google_choose": "Pick your business",
  "reputation.google_choose_lead": "The businesses you manage with this Google account.",
  "reputation.google_choose_none": "This Google account does not manage a Business Profile. Sign in with the account that manages your business on Google.",
  "reputation.google_use": "Use this business",
  "reputation.google_saved": "Google business connected. BRES is fetching your reviews now.",
  "reputation.google_change": "Other business",
  "reputation.google_remove": "Disconnect",
  "reputation.google_remove_title": "Disconnect Google reviews?",
  "reputation.google_remove_body": "Your site stops showing Google reviews after the next publication. If no other site uses this Google account, BRES revokes access and deletes the fetched reviews within 7 days.",
  "reputation.google_sync": "Fetch now",
  "reputation.google_sync_started": "BRES is fetching your reviews now",
  "reputation.google_last": "Last fetched on {when}",
  "reputation.google_first_sync": "BRES is fetching your reviews for the first time. This usually takes a minute.",
  "reputation.google_schedule": "BRES fetches your reviews from your Google Business Profile every 6 hours. It costs nothing.",
  "reputation.google_reauth": "Google asks you to sign in again. Until then your site shows the last fetched reviews for at most 3 days; after that only the button to Google.",
  "reputation.google_error": "The last fetch did not work ({code}). BRES will try again by itself.",
  "reputation.google_preview": "How it looks on your site",
  "reputation.google_preview_note": "From your Google Business Profile, newest first. Your site shows ten and lets visitors load more.",
  "reputation.google_preview_none": "Your business has no reviews on Google yet. Your site then shows only the button to write a review.",
  "reputation.google_count": "{count, plural, one {# review on Google} other {# reviews on Google}}",
  "reputation.google_publish": "Put on the site",
  "reputation.google_published": "Publication started",
  "reputation.google_ask": "Ask clients for a review",
  "reputation.google_ask_lead": "Send this link after a sale or stay. It opens the review window of your business on Google directly. Ask everyone, not only happy clients.",
  "reputation.google_ask_copy": "Copy",
  "reputation.google_links": "Just a button to Google",
  "reputation.google_links_lead": "Not connected yet? Then put a button on your site that opens the review window of your business on Google. Your score and reviews are added once you connect your business above.",
  "reputation.google_links_active": "On your site",
  "reputation.google_links_review": "Review link from Google",
  "reputation.google_links_review_hint": "In your Google Business Profile: Ask for reviews, then copy the link.",
  "reputation.google_links_profile": "Link to your business on Google Maps (optional)",
  "reputation.google_links_save": "Save",
  "reputation.google_links_saved": "Button to Google saved",
  "reputation.google_links_remove": "Remove"
}
